import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, SocketService, DateService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-inspection-dialog',
  templateUrl: './inspection-dialog.component.html',
  styleUrls: ['./inspection-dialog.component.scss'],
  providers: [DialogService],
})
export class InspectionDialogComponent implements OnInit, OnDestroy {
  // @Input() isArchived: boolean;
  isUpdating: boolean = false;
  inspection: any = {};
  categoryItemText: string = '';
  workStatus: string = '';
  serviceId: string = '';
  orderId: string = '';
  socketListeners: Subject<boolean> = new Subject<boolean>();
  isSubmitting: boolean = false;
  isDVIRecommendation: boolean = false;
  statusServices = [
    { name: 'All', checked: false },
    { name: 'Good', checked: false },
    { name: 'Average', checked: false },
    { name: 'Poor', checked: false },
  ]
  closeAfterAction = false;
  statusFilter = '';
  isArchived = false;
  isFinalized = false;
  currentLang: string = 'en';
  companyLocalization: boolean = false;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private socketService: SocketService,
    private dateService: DateService
  ) { }

  ngOnInit() {
    const { isArchived, isFinalized } = this.dialogConfig.data;
    this.currentLang = this.dialogConfig.data.currentLang;
    this.companyLocalization = this.dialogConfig.data.companyLocalization;
    this.isArchived = isArchived;
    this.isFinalized = isFinalized;
    this.getInspection();
    this.statusFilter = this.statusServices[0].name;
  }

  ngOnDestroy() {
    this.socketListeners.unsubscribe();
  }

  getInspection() {
    const { inspectionId = '', orderId = '' } = this.dialogConfig.data;

    if (inspectionId) {
      this.httpService.getEstimateInspectionDetails(inspectionId, orderId, true).then(
        (inspection: any) => {
          this.setInspection(inspection);
          // this.isArchived = this.inspection.estimateId.isArchived;

          if (inspection.estimateId && inspection.estimateId.services && inspection.estimateId.services.length) {
            for (let i = 0; i < inspection.estimateId.services.length; i++) {
              const service = inspection.estimateId.services[i];

              if (service._id === inspection.serviceId) {
                this.workStatus = service.status;
                this.serviceId = service._id;
                this.orderId = inspection.estimateId._id;
                this.setSocketListener();
                break;
              }
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  setInspection(inspection: any) {
    this.inspection = inspection;
    const counts = {
      items: 0,
      categories: 0,
    };

    if (inspection.category && inspection.category.length) {
      counts.categories = inspection.category.length;

      inspection.category.forEach((category: any) => {
        if (category.inspectionItems.length) {
          counts.items += category.inspectionItems.length;
          category.inspectionItems.forEach((inspection) => {
            if (inspection.attachments && inspection.attachments.length)
              inspection.attachments.forEach((attachment) => {
                attachment.createdAtTz = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(attachment.createdAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
              });
          });
        }
      });
    }

    this.categoryItemText = `
    ${counts.categories} ${counts.categories > 1 ? 'categories' : 'category'}
    ${counts.items} ${counts.items > 1 ? 'items' : 'item'}
    `;
  }

  setSocketListener() {
    this.socketService
      .socketOn(`r_order_${this.orderId}`)
      .pipe(takeUntil(this.socketListeners))
      .subscribe((data) => {
        if (!data) {
          return;
        }

        if (data.type === 'work_status') {
          this.setWorkStatus(data);
        }
      });
  }

  setWorkStatus(data: any) {
    if (data.workType === 'service') {
      if (this.serviceId === data.workId && data.status === 'inprogress') {
        this.workStatus = data.status;
      }
    }
  }

  handleSubmit() {
    if (this.isUpdating) {
      return;
    }

    this.isUpdating = true;
    this.httpService.updateServiceInspection(this.inspection._id, this.inspection).then(
      (inspection: any) => {
        this.dynamicDialogRef.close({
          isSuccess: true,
          data: { inspection },
        });
        this.isUpdating = false;
      },
      (err) => {
        this.isUpdating = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }

  showUnsavedChanges() {
    let isValid = false;
    if (this.inspection?.category && this.inspection?.category?.length > 0)
      this.inspection.category.forEach(element => {
        element.inspectionItems.forEach(element => {
          if (element.isValid) {
            isValid = true;
          }
        });
      });
    return isValid;
  }

  onChange(type, event) {
    this.statusFilter = event;
  }

  openStatusFilter() {
    this.closeAfterAction = !this.closeAfterAction;
  }

  removeFilter() {
    this.statusFilter = this.statusServices[0].name;
  }

}
